var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from "react";
import { generateRadixColors } from "../../helpers/colors/generateRadixColors";
import colors_new from "../../tokens/colors_new.json";
var ThemeContext = createContext({
    theme: {
        colorPalette: {
            primary: __assign({ main: colors_new.primary.accent, appearance: colors_new.appearance }, generateRadixColors({
                appearance: colors_new.appearance,
                accent: colors_new.primary.accent,
                background: colors_new.appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: colors_new.gray,
            })),
            secondary: __assign({ main: colors_new.secondary.accent, appearance: colors_new.appearance }, generateRadixColors({
                appearance: colors_new.appearance,
                accent: colors_new.secondary.accent,
                background: colors_new.appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: colors_new.gray,
            })),
            danger: __assign({ main: colors_new.danger.accent, appearance: colors_new.appearance }, generateRadixColors({
                appearance: colors_new.appearance,
                accent: colors_new.danger.accent,
                background: colors_new.appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: colors_new.gray,
            })),
            warning: __assign({ main: colors_new.warning.accent, appearance: colors_new.appearance }, generateRadixColors({
                appearance: colors_new.appearance,
                accent: colors_new.warning.accent,
                background: colors_new.appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: colors_new.gray,
            })),
            success: __assign({ main: colors_new.success.accent, appearance: colors_new.appearance }, generateRadixColors({
                appearance: colors_new.appearance,
                accent: colors_new.success.accent,
                background: colors_new.appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: colors_new.gray,
            })),
            info: __assign({ main: colors_new.info.accent, appearance: colors_new.appearance }, generateRadixColors({
                appearance: colors_new.appearance,
                accent: colors_new.info.accent,
                background: colors_new.appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: colors_new.gray,
            })),
        },
    },
    setTheme: {},
});
var useTheme = function () {
    return useContext(ThemeContext);
};
var useUpdateTheme = function () {
    var setTheme = useTheme().setTheme;
    return function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var _p = _a.accent, accent = _p === void 0 ? {
            primary: colors_new.primary.accent,
            secondary: colors_new.secondary.accent,
            danger: colors_new.danger.accent,
            warning: colors_new.warning.accent,
            success: colors_new.success.accent,
            info: colors_new.info.accent,
        } : _p, _q = _a.gray, gray = _q === void 0 ? colors_new.gray : _q, _r = _a.appearance, appearance = _r === void 0 ? colors_new.appearance : _r;
        return setTheme({
            colorPalette: {
                primary: __assign({ main: (_b = accent["primary"]) !== null && _b !== void 0 ? _b : colors_new.primary.accent, appearance: appearance }, generateRadixColors({
                    appearance: appearance,
                    accent: (_c = accent["primary"]) !== null && _c !== void 0 ? _c : colors_new.primary.accent,
                    background: appearance === "light" ? colors_new.light_background : colors_new.dark_background,
                    gray: gray,
                })),
                secondary: __assign({ main: (_d = accent["secondary"]) !== null && _d !== void 0 ? _d : colors_new.secondary.accent, appearance: appearance }, generateRadixColors({
                    appearance: appearance,
                    accent: (_e = accent["secondary"]) !== null && _e !== void 0 ? _e : colors_new.secondary.accent,
                    background: appearance === "light" ? colors_new.light_background : colors_new.dark_background,
                    gray: gray,
                })),
                danger: __assign({ main: (_f = accent["danger"]) !== null && _f !== void 0 ? _f : colors_new.danger.accent, appearance: appearance }, generateRadixColors({
                    appearance: appearance,
                    accent: (_g = accent["danger"]) !== null && _g !== void 0 ? _g : colors_new.danger.accent,
                    background: appearance === "light" ? colors_new.light_background : colors_new.dark_background,
                    gray: gray,
                })),
                warning: __assign({ main: (_h = accent["warning"]) !== null && _h !== void 0 ? _h : colors_new.warning.accent, appearance: appearance }, generateRadixColors({
                    appearance: appearance,
                    accent: (_j = accent["warning"]) !== null && _j !== void 0 ? _j : colors_new.warning.accent,
                    background: appearance === "light" ? colors_new.light_background : colors_new.dark_background,
                    gray: gray,
                })),
                success: __assign({ main: (_k = accent["success"]) !== null && _k !== void 0 ? _k : colors_new.success.accent, appearance: appearance }, generateRadixColors({
                    appearance: appearance,
                    accent: (_l = accent["success"]) !== null && _l !== void 0 ? _l : colors_new.success.accent,
                    background: appearance === "light" ? colors_new.light_background : colors_new.dark_background,
                    gray: gray,
                })),
                info: __assign({ main: (_m = accent["info"]) !== null && _m !== void 0 ? _m : colors_new.info.accent, appearance: appearance }, generateRadixColors({
                    appearance: appearance,
                    accent: (_o = accent["info"]) !== null && _o !== void 0 ? _o : colors_new.info.accent,
                    background: appearance === "light" ? colors_new.light_background : colors_new.dark_background,
                    gray: gray,
                })),
            },
        });
    };
};
var ThemeProvider = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var _p = _a.accent, accent = _p === void 0 ? {
        primary: colors_new.primary.accent,
        secondary: colors_new.secondary.accent,
        danger: colors_new.danger.accent,
        warning: colors_new.warning.accent,
        success: colors_new.success.accent,
        info: colors_new.info.accent,
    } : _p, _q = _a.gray, gray = _q === void 0 ? colors_new.gray : _q, _r = _a.appearance, appearance = _r === void 0 ? colors_new.appearance : _r, children = _a.children;
    var _s = React.useState({
        colorPalette: {
            primary: __assign({ main: (_b = accent["primary"]) !== null && _b !== void 0 ? _b : colors_new.primary.accent, appearance: appearance }, generateRadixColors({
                appearance: appearance,
                accent: (_c = accent["primary"]) !== null && _c !== void 0 ? _c : colors_new.primary.accent,
                background: appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: gray,
            })),
            secondary: __assign({ main: (_d = accent["secondary"]) !== null && _d !== void 0 ? _d : colors_new.secondary.accent, appearance: appearance }, generateRadixColors({
                appearance: appearance,
                accent: (_e = accent["secondary"]) !== null && _e !== void 0 ? _e : colors_new.secondary.accent,
                background: appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: gray,
            })),
            danger: __assign({ main: (_f = accent["danger"]) !== null && _f !== void 0 ? _f : colors_new.danger.accent, appearance: appearance }, generateRadixColors({
                appearance: appearance,
                accent: (_g = accent["danger"]) !== null && _g !== void 0 ? _g : colors_new.danger.accent,
                background: appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: gray,
            })),
            warning: __assign({ main: (_h = accent["warning"]) !== null && _h !== void 0 ? _h : colors_new.warning.accent, appearance: appearance }, generateRadixColors({
                appearance: appearance,
                accent: (_j = accent["warning"]) !== null && _j !== void 0 ? _j : colors_new.warning.accent,
                background: appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: gray,
            })),
            success: __assign({ main: (_k = accent["success"]) !== null && _k !== void 0 ? _k : colors_new.success.accent, appearance: appearance }, generateRadixColors({
                appearance: appearance,
                accent: (_l = accent["success"]) !== null && _l !== void 0 ? _l : colors_new.success.accent,
                background: appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: gray,
            })),
            info: __assign({ main: (_m = accent["info"]) !== null && _m !== void 0 ? _m : colors_new.info.accent, appearance: appearance }, generateRadixColors({
                appearance: appearance,
                accent: (_o = accent["info"]) !== null && _o !== void 0 ? _o : colors_new.info.accent,
                background: appearance === "light"
                    ? colors_new.light_background
                    : colors_new.dark_background,
                gray: gray,
            })),
        },
    }), theme = _s[0], setTheme = _s[1];
    return (_jsx(ThemeContext.Provider, __assign({ value: { theme: theme, setTheme: setTheme } }, { children: children })));
};
export { ThemeProvider, useTheme, useUpdateTheme };
